import { Directive } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { BaseModalComponent } from './base-modal.compnent';

@Directive()
export abstract class BaseFormComponent extends BaseModalComponent {
    public clearControl(control: AbstractControl | null, defaultValue: string | null = '', event?: any) {
        if (event) {
            event?.stopPropagation();
            event?.preventDefault();
        }
        control?.setValue(defaultValue);
    }
}
